import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import i18n from './localization'
import VueI18n from 'vue-i18n'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueResource from 'vue-resource'
import Vuex from 'vuex'
import { EventBus } from './utilites/eventBus'
import PortalVue from 'portal-vue'

Vue.use(VueI18n);
Vue.use(BootstrapVue);
Vue.use(VueResource);
Vue.use(Vuex);
Vue.use(PortalVue);

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
library.add(fas);
library.add(far);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

// URL берется из Env переменной
// В случае с local dev - dev.env
// В случае с prod - prod.env подставляется при сборке
const API_URL = process.env.ROOT_API;

Vue.http.options.root = API_URL;

const publicUrls = ["login", "ping", "refresh_token", "logout"];
let refreshRequest = null;

function saveTokenPair(body) {
  if (!body || !body.access_token || !body.refresh_token) {
    return false;
  }

  localStorage.setItem("token", body.access_token);
  localStorage.setItem("refresh_token", body.refresh_token);
  return true;
}

function logoutAndRedirect() {
  return store.dispatch("logout").then(() => {
    router.push('/login').catch(() => {});
  });
}

function updateRefreshToken() {
  const refreshToken = localStorage.getItem("refresh_token");
  if (!refreshToken) {
    return Promise.reject(new Error("Refresh token is missing"));
  }

  if (!refreshRequest) {
    refreshRequest = Vue.http.post("refresh_token", {
      refresh_token: refreshToken
    }).then(response => {
      if (!saveTokenPair(response.body)) {
        throw new Error("Refresh response does not contain a token pair");
      }
      return response.body.access_token;
    }).finally(() => {
      refreshRequest = null;
    });
  }

  return refreshRequest;
}

Vue.http.interceptors.unshift((request, next) => {
  const url = request._originalUrl || request.url;
  request._originalUrl = url;
  if (!request._apiRootApplied) {
    request.url = API_URL + url;
    request._apiRootApplied = true;
  }
  const isPublicUrl = publicUrls.includes(url);
  const token = localStorage.getItem("token");
  if (token) {
    request.headers.set('Authorization', 'Bearer '+ token);
  } else if (!isPublicUrl) {
    router.push('/login').catch(() => {});
    return;
  }

  next((response) => {
    if (response.status === 404) {
      if (!request.ignore404) {
      EventBus.$emit('http-error-404');
      }
    }

    if (!isPublicUrl) {
      if (response.status === 401) {
        if (!request._retriedAfterRefresh && localStorage.getItem("refresh_token")) {
          request._retriedAfterRefresh = true;
          return updateRefreshToken().then(accessToken => {
            request.headers.set('Authorization', 'Bearer ' + accessToken);
            return Vue.http(request);
          }, error => {
            logoutAndRedirect();
            return Promise.reject(error);
          });
        }

        logoutAndRedirect();
      }

      if (response.status === 403) {
        EventBus.$emit('http-error-403');
      }
    }
  })
});

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js